module.exports = __webpack_public_path__ + "img/iconHistoryGate.61a84293.svg";